import { FECHAR_LOADING } from '../types'

export default function fecharLoading () {
  return {
    type: FECHAR_LOADING,
    payload: null
  }
}
